import { useCallback } from "react";
import type { ClipboardEvent } from "react";
import { useFormContext } from "react-hook-form";

import { cleanPastedEmail } from "@RequestFormV2/sections/Schedule/utils/cleanPastedEmail";

/**
 * Paste handler for schedule email inputs: cleans the value the paste would produce
 * and only takes over the paste when cleaning changes it.
 */
export function useEmailPasteCleanup(fieldPath: string) {
  const { setValue } = useFormContext();

  return useCallback(
    (event: ClipboardEvent<HTMLInputElement>) => {
      const input = event.currentTarget;
      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? input.value.length;
      const pastedValue = input.value.slice(0, start) + event.clipboardData.getData("text") + input.value.slice(end);
      const cleanedValue = cleanPastedEmail(pastedValue);
      if (cleanedValue === pastedValue) return;

      event.preventDefault();
      setValue(fieldPath, cleanedValue, { shouldDirty: true });
    },
    [fieldPath, setValue],
  );
}
